/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BlueskyNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABi0lEQVR4nO1TPUsDQRBdxY/Oj85KOy39CWkPc7szEdYZoxKxCFoo4h/If5Bgof4FRUwpYicIYrRJLVhZWBmI+BWZi8R43l7uGrHwwVT73rw3u7NK/eNPwQDvaOBHA1zJ5uamk+qEKxrRaqCy2wCpbpCbn/WigZa7NReOcL90VE9qIPWugded/BxvCKdTI1PEpbkLGTQ10JsP8xjRPKuBX8N8A3TrngD4+ocAW6kQabLNM3YqYtoWF+kqzqASJTIt4WWxWOzPZDJ9GujCxTPAR3FXVHYKMZhk0yBtxXEM0rbTwAda6mLwIBXLQV50GgTjI5/FJ2R3AZ1KDxUHz/MGNdKaRjrUSFUD1Ihp2Ghx+MAgr1prB1QSZLP5UYO8b5CfEqQWkz2AwohKChk17fVo5JNEzUulUu/3r8+dac+DilwAelZK9SQy0UjHjpQFg7ySev/DmLF2TAPXQh+tKhsin80g3YTWtyYalQbW2mF5aA10L/fr+3a8HWA2PyHvFJwB7XrewlCq5v/4VXwADt+ZFPX9D9oAAAAASUVORK5CYII=)
 */
export const BlueskyNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.9 5.08C8.97 6.64 11.2 9.8 12 11.5v4.5c0-.1-.04.01-.12.24-.42 1.27-2.08 6.19-5.88 2.25-2-2.07-1.07-4.14 2.57-4.77-2.09.36-4.43-.23-5.07-2.55-.19-.66-.5-4.77-.5-5.33 0-2.77 2.41-1.9 3.9-.77Zm10.2 0C15.03 6.64 12.8 9.8 12 11.5v4.5c0-.1.04.01.12.24.42 1.27 2.08 6.19 5.88 2.25 2-2.07 1.07-4.14-2.57-4.77 2.09.36 4.43-.23 5.07-2.55.18-.66.5-4.77.5-5.33 0-2.77-2.41-1.9-3.9-.77Z"
        className={colorClass}
      />
    </svg>
  );
};
